module.exports = __webpack_public_path__ + "static/media/mini.f4223e5e.jpg";